export default "__VITE_ASSET__CIiPGLG5__"